import React from 'react';

import { Switch, Route } from 'react-router-dom';

import SimuladorPrevidencia from '../views/SimuladorPrevidencia';

export const Routes: React.FC = () => (
  <Switch>
    <Route path="/SimuladorCDPuro" component={SimuladorPrevidencia} exact />
  </Switch>
);
